<template>
  <div>
    <v-dialog v-model="open" max-width="500px" persistent>
      <v-card :loading="loading">
        <v-card-title>
          <template v-if="editing">Категорія {{ category.name }}</template>
          <template v-else>Нова категорія</template>
        </v-card-title>
        <v-card-text>
          <v-form
            :disabled="loading"
            @submit.prevent="submit"
            id="category-form"
          >
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="form.name"
                  type="text"
                  label="Назва"
                  :error-messages="nameErrors"
                  @input="$v.form.name.$touch()"
                  @blur="$v.form.name.$touch()"
                />
              </v-col>
              <v-col cols="12">
                <v-radio-group
                  v-model="form.type"
                  row
                  :error-messages="typeErrors"
                  @change="$v.form.type.$touch()"
                >
                  <v-radio label="Витрати" value="EXPENSE" />
                  <v-radio label="Доходи" value="INCOME" />
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <color-picker v-model="form.color" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-icon
            v-if="editing"
            :disabled="loading"
            @click="isDeleteOpen = true"
            >mdi-delete</v-icon
          >
          <v-spacer />
          <v-btn text :disabled="loading" @click="close">Скасувати</v-btn>
          <v-btn
            type="submit"
            color="primary"
            :disabled="loading"
            form="category-form"
          >
            <template v-if="editing">Зберегти</template>
            <template v-else>Додати</template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isDeleteOpen" max-width="300px">
      <v-card>
        <v-card-title class="text-h5">Видалити категорію?</v-card-title>
        <v-card-text
          >Усі транзакції з цією категорією будуть видалені!</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" text @click="isDeleteOpen = false"
            >Скасувати</v-btn
          >
          <v-btn color="error" text @click="confirmDelete">Видалити</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import { getFieldErrorMessages } from "@/helpers/errors";
import ColorPicker from "@/components/shared/ColorPicker";

export default {
  name: "CategoryDialog",
  components: { ColorPicker },
  mixins: [validationMixin],
  validations: {
    form: {
      name: { required, maxLength: maxLength(64) },
      type: { required },
    },
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    type: String,
    category: {
      type: Object,
    },
  },
  data() {
    return {
      isDeleteOpen: false,
      form: {
        name: null,
        type: null,
        color: null,
      },
    };
  },
  computed: {
    nameErrors() {
      return getFieldErrorMessages(this.$v.form.name, {
        required: "Введіть назву",
        maxLength: "Назва має бути коротшою або дорівнювати 64 символам",
      });
    },
    typeErrors() {
      return getFieldErrorMessages(this.$v.form.type, {
        required: "Вкажіть тип",
      });
    },
  },
  watch: {
    open(newValue) {
      if (newValue === true) {
        this.resetForm();
      }
      if (!this.editing) {
        this.form.type = this.type;
      }
    },
    category: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.form = cloneDeep(newValue);
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    resetForm() {
      this.$v.$reset();
      this.form = {
        name: null,
        type: null,
        color: null,
      };
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.editing) {
          this.$emit("update-category", {
            id: this.form.id,
            name: this.form.name,
            type: this.form.type,
            color: this.form.color,
          });
        } else {
          this.$emit("create-category", {
            name: this.form.name,
            type: this.form.type,
            color: this.form.color,
          });
        }
      }
    },
    confirmDelete() {
      this.isDeleteOpen = false;
      this.$emit("delete-category", this.category);
    },
  },
};
</script>
